import React from 'react';
import { format } from 'date-fns';
import { Campaignfooter, FooterTxt, FooterTxtCancle, DummySpacer }from './style';

//캠페인 하단
export default function GroupProjectMainFooter({
  challengeInfo,
  requestJoin,
  setInitCenterModal,
  setCenterModalVisible,
  setCenterModalDataList,
  setOnModalComplete,
  setOnModalCancel,
  showConfirmationJoinModal
}) {

  const passedToday = (d1) => {
    let d2 = new Date();
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    return d1 >= d2;
  };

  const checkProceeding = (startDate, endDate) => {
    const currDate = new Date();
    currDate.setHours(0, 0 , 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0 ,0 , 0);

    if(currDate > startDate)
    {
      if(currDate <= endDate)
      {
        return true;
      }
    }
    return false;
  }

  let campaignStartDate = (challengeInfo?.start_date) ? format(new Date(challengeInfo.start_date), 'MM/dd'): null;
  const displayDom = [];
  if(passedToday(new Date(challengeInfo.end_date)))
  {
    if((!challengeInfo.is_member) && (challengeInfo.start_date === null || passedToday(new Date(challengeInfo.start_date))))
    {
      displayDom.push(
        <React.Fragment key={"join-challenge-btn"}>
          <Campaignfooter>
            <FooterTxt
              onClick={() => {
                if(challengeInfo?.join_description)
                {
                  showConfirmationJoinModal();
                  return;
                }
                if(challengeInfo?.share_req)
                {
                  requestJoin();
                  return;
                }
                setCenterModalVisible(true); 
                if(campaignStartDate)
                {
                  setCenterModalDataList({title: '챌린지 참여하기',description:`${campaignStartDate}일부터 챌린지가 시작돼요!\n 시작되기 전에 알려드릴게요😉`});  
                }
                else
                {
                  setCenterModalDataList({title: '챌린지 참여하기',description:`오늘부터 챌린지가 시작돼요.\n 완주까지 화이팅!😉`});
                }
                
                setOnModalComplete(()=>()=>{
                  if(requestJoin)
                  {
                    requestJoin();
                  }
                  setInitCenterModal(true);
                })
                setOnModalCancel(()=>()=>{
                  setInitCenterModal(true);
                })
              }}
            >
              {'챌린지 참여하기'}
            </FooterTxt>
          </Campaignfooter>
          <DummySpacer key={"join-challenge-btn-dummy-spacer"}></DummySpacer>
      </React.Fragment>
      )
    }
    else if(challengeInfo.is_member)
    {
      displayDom.push(
        <FooterTxtCancle key={"participating-challenge-btn"}>
          {'챌린지 참여중'}
        </FooterTxtCancle>
      );
    }
    else
    {
      if(!challengeInfo.is_member && challengeInfo.start_date && checkProceeding(new Date(challengeInfo.start_date), new Date(challengeInfo.end_date)))
      {
        displayDom.push(
          <FooterTxtCancle key={"proceeding-challenge-btn"}>
            {'챌린지 진행중'}
          </FooterTxtCancle>
        );
      }
    }
  }
  else
  {
    displayDom.push(
      <FooterTxtCancle key={"end-challenge-btn"}>
        {'챌린지 종료'}
      </FooterTxtCancle>
    )
  }
  return (
    <>
      {displayDom}   
    </>
  )
}
